<script>
export default {
  name: 'AppPrimaryButton',
  inheritAttrs: false,
  props: {
    text: String,
    state: {
      type: String,
      validator(value) {
        return ['enabled', 'disabled', 'loading', 'error'].includes(value);
      }
    },
    size: {
      type: String,
      validator(value) {
        return ['sm', 'md', 'lg'].includes(value);
      }
    },
    full: Boolean,
    tooltip: {
      type: String
    }
  },

  computed: {
    sizeClass() {
      return this.size || 'md';
    },
    buttonDisabled() {
      return this.state === 'processing' || this.state === 'disabled';
    }
  }
};
</script>

<template>
  <!-- transparent wrapper, see: https://vuejs.org/v2/guide/components-custom-events.html#Binding-Native-Events-to-Components -->
  <button
    v-bind="$attrs"
    v-on="$listeners"
    :disabled="buttonDisabled"
    :class="[state, sizeClass, { full }, { 'tooltip-top tooltip-light': tooltip }]"
    class="button"
    :data-tooltip="tooltip"
  >
    <app-loader v-if="state === 'loading'" class="loader" />
    <slot>
      <span v-if="state !== 'loading'">{{ text }}</span>
    </slot>
  </button>
</template>

<style lang="scss" scoped>
// TODO: transition button width when showing loader
.button {
  font-size: 15px;
  font-weight: 600;
  line-height: 32px;
  height: 38px;
  color: white;
  background: transparent linear-gradient(291deg, #1b2887 0%, #5669ef 100%);
  box-shadow: 0 4px 7px #001ddb40;
  border-radius: 8px;
  border: 0;
  transition: 0.2s ease-out; // TODO: Doesn't seem to work

  // fixed is necessary to prevent a jump when the button content changes (e.g to `loading` state)
  &.sm {
    padding: 2px 12px;
    height: 28px;
    font-size: 13px;
    line-height: 12px;
  }

  &.md {
    height: 38px;
    padding: 4px 26px;
    font-size: 15px;
  }

  // TODO
  &.lg {
    padding: 6px 26px;
    height: 48px;
    font-size: 17px;
    line-height: 32px;
  }

  &.full {
    width: 100%;
  }

  &.disabled,
  &[disabled] {
    color: var(--purple-light-3);
    background: #fff;
    box-shadow: 0 3px 8px #303b5614;
    cursor: default;

    &:hover {
      background: #fff;
    }
  }

  &.loading {
    opacity: 0.5;
    cursor: default;

    &:hover {
      opacity: 0.5; // hide hover effect, it should look as disabled
    }
  }

  &:hover {
    background: transparent linear-gradient(283deg, #1e2b8d 0%, #4152cb 100%);
  }

  &:active {
    background: transparent linear-gradient(283deg, #1e2b8d 0%, #3744ab 100%);
  }

  &:focus {
    outline: none;
  }
}
</style>
